<template>
    <div class="grid grid-cols-2 m-auto bg-white px-1 py-1 rounded-xl h-[54px] text-16" data-cy="container_mission_tab_menu">
        <div @click="clickTransaction()"
             data-cy="btn_mission_tab_transaction"
             class="flex justify-center items-center text-center cursor-pointer rounded-lg py-1.5"
             :class="[getTabClass('transaction')]">{{lbl.mission.mission_transaction}}</div>
        <div @click="clickOther()"
             data-cy="btn_mission_tab_other"
             class="flex justify-center items-center text-center cursor-pointer rounded-lg py-1.5"
             :class="[getTabClass('other')]">{{lbl.mission.mission_other}}</div>
    </div>
     <div v-if="active == 'transaction'">
        <Transaction v-if="!isComingSoonTransaction" data-cy="component_mission_transaction" @ComingSoon="ComingSoonTransaction($event)"></Transaction>
        <div class="pb-10" data-cy="container_mission_transaction_coming_soon" v-else>
            <div class="flex flex-col my-auto justify-center items-center mt-20">
                <div class="text-16 text-center text-white pb-4">
                    {{ lbl.mission.mission_comingsoon }}
                </div>
                <div>
                    <img class="w-16" :src="imgUrl()" />
                </div>
            </div>
        </div>
    </div>
    <div class="pb-10" v-else-if="active == 'other'">
        <OtherMission data-cy="component_mission_other"></OtherMission>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ConfigManager from '@/config/ConfigManager.js';
//component
import OtherMission from './OtherMission/OtherMission.vue';
import Transaction from './MissionTransaction/Transaction.vue'
export default {
    name: 'TabMenuMission',
    mixins: [ LocaleMixin ],
    components: {
        OtherMission,
        Transaction
    },
    data: function() {
        return {
            active: '',
            isComingSoonTransaction: null
        }
    },
    created: async function() {
        this.active = this.$route.params.tab;
        if (Util.isEmptyStr(this.active)) {
            this.active = 'transaction'
        }
        this.ComingSoonTransaction();
    },
    methods: {
        getTabClass: function(tab) {
            if (tab == this.active) {
                return 'bg-a-blue-0064ff text-a-blue-f2f5ff font-medium';
            } else {
                return 'text-a-black-000926';
            }
        },
        ComingSoonTransaction: async function(soon) {
            this.isComingSoonTransaction = await soon;
            if (this.isComingSoonTransaction) {
                this.active = 'other'
            } else {
                return true
            }
        },
        clickTransaction: function() {
            if (this.active == 'transaction') return
            this.active = 'transaction'
        },
        clickOther: function() {
            if (this.active == 'other') return
            this.active = 'other'

            this.tracking.event('mission_othermissions', 'click_othermissions', null, null);
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-coming-soon.png`;
        },
    },
}
</script>
